import { getProviderNameForBillRecord } from '@demandproai/shared';

export const normalizeMedicalBillAmountForInput = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).replace(/[^0-9.-]/g, '');
};

// The array index shifts when a row is removed, which would hand a row's in-progress
// rename to a different record. Rows are unique by provider name because the grouping
// that feeds this table is keyed by it, so it stands in when a record has no _id yet.
// The prefixes keep the three sources from colliding with one another.
export const getMedicalBillRowKey = ({ clientId, record, index }) => {
  if (record?._id) return `${clientId}-id:${record._id}`;

  const providerName = getProviderNameForBillRecord(record).trim().toLowerCase();
  if (providerName) return `${clientId}-name:${providerName}`;

  return `${clientId}-index:${index}`;
};
